export default {
  install(Vue) {
    Vue.directive('anchor',{
      inserted : function(el,binding){
        el.onclick = function(){
          console.log(binding.value)
          document.querySelector('#anchor-'+binding.value).scrollIntoView(true);
        }
      }
    })
  },
};



// WEBPACK FOOTER //
// ./src/utils/anchor-directive.js